import type { CSSProperties } from 'react'

import type { ChatCard } from '../../lib/assistant'

/** The chart's numbers and unit are server-filled; its heading is the matching card's. */
export function MiniBars({ chart, title }: { chart: NonNullable<ChatCard['chart']>; title: string }) {
  // CSS lays out these raw payload values on one shared domain.
  const unit = chart.unit ? ` ${chart.unit}` : ''
  return (
    <div
      className="assistant-mini-bars"
      role="img"
      aria-label={`${title}: Before ${chart.before}${unit}; After ${chart.after}${unit}`}
      style={{ '--assistant-before': chart.before, '--assistant-after': chart.after } as CSSProperties}
    >
      {(['before', 'after'] as const).map((when) => {
        const value = chart[when]
        return (
          <div key={when} className="assistant-mini-bars__row" aria-hidden="true" style={{ '--assistant-value': value } as CSSProperties}>
            <span>{when === 'before' ? 'Before' : 'After'}</span>
            <div className="assistant-mini-bars__track">
              <span className="assistant-mini-bars__zero" />
              <span className={`assistant-mini-bars__bar assistant-mini-bars__bar--${when}`} />
            </div>
            <span className="assistant-mini-bars__value">{value}{unit}</span>
          </div>
        )
      })}
    </div>
  )
}
